export const deClientPortalPlausibilityPdf = {
    loading: 'Dokument wird geladen ...',
    actions: {
        previousPage: 'Vorherige Seite',
        nextPage: 'Nächste Seite',
        zoomOut: 'Verkleinern',
        zoomIn: 'Vergrößern',
        highlight: 'Textmarker',
        downloadDraft: 'Entwurf downloaden',
        newPageAnnotation: 'Neue Anmerkung zu dieser Seite',
    },
    search: {
        placeholder: 'PDF durchsuchen',
        results: '{{current}} von {{total}} {{resultLabel}}',
        resultSingle: 'Ergebnis',
        resultPlural: 'Ergebnisse',
        previousResult: 'Vorheriges Ergebnis',
        nextResult: 'Nächstes Ergebnis',
        reset: 'Suche zurücksetzen',
    },
}
